import { render, staticRenderFns } from "./HomeFeedBookNow.vue?vue&type=template&id=0b88e267&scoped=true"
import script from "./HomeFeedBookNow.vue?vue&type=script&lang=js"
export * from "./HomeFeedBookNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b88e267",
  null
  
)

export default component.exports